// TODO: create eslint rule to forbid check globalThis
export const isClient = (): boolean => globalThis.window !== undefined
